/**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: Apache-2.0
 */

/**
 * Namespace for themes.
 *
 * @namespace Blockly.Themes
 */
import * as goog from '../../closure/goog/goog.js';
goog.declareModuleId('Blockly.Themes');

import {Classic} from './classic.js';
import {Zelos} from './zelos.js';


export {Classic, Zelos};
